import {
  ADD_DOCUMENT_TO_SELECTION,
  REMOVE_DOCUMENT_FROM_SELECTION,
  CLEAR_DOCUMENT_SELECTION,
  UPDATE_DOCUMENT_IN_SELECTION,
} from "./actions";

// Load selected documents from localStorage if available
const loadSelectedDocumentsFromStorage = () => {
  try {
    const storedDocuments = localStorage.getItem("selectedDocuments");
    return storedDocuments ? JSON.parse(storedDocuments) : [];
  } catch (error) {
    console.error("Error loading selected documents from localStorage:", error);
    return [];
  }
};

// Save selected documents to localStorage
const saveSelectedDocumentsToStorage = (documents) => {
  try {
    localStorage.setItem("selectedDocuments", JSON.stringify(documents));
  } catch (error) {
    console.error("Error saving selected documents to localStorage:", error);
  }
};

export const initialState = {
  selectedDocuments: loadSelectedDocumentsFromStorage(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_DOCUMENT_TO_SELECTION: {
      const updatedDocuments = [...state.selectedDocuments, action.payload];
      saveSelectedDocumentsToStorage(updatedDocuments);
      return {
        ...state,
        selectedDocuments: updatedDocuments,
      };
    }
    case REMOVE_DOCUMENT_FROM_SELECTION: {
      const filteredDocuments = state.selectedDocuments.filter(
        (doc) => doc.pid !== action.payload.pid
      );
      saveSelectedDocumentsToStorage(filteredDocuments);
      return {
        ...state,
        selectedDocuments: filteredDocuments,
      };
    }
    case CLEAR_DOCUMENT_SELECTION: {
      saveSelectedDocumentsToStorage([]);
      return {
        ...state,
        selectedDocuments: [],
      };
    }
    case UPDATE_DOCUMENT_IN_SELECTION: {
      const updatedDocuments = state.selectedDocuments.map((doc) => {
        if (doc.pid === action.payload.pid) {
          // Ensure call_number is available at the top level for consistency
          const updatedDoc = {
            ...doc,
            ...action.payload,
            call_number:
              action.payload.metadata?.call_number ||
              action.payload.call_number,
            metadata: {
              ...doc.metadata,
              ...action.payload.metadata,
            },
          };
          return updatedDoc;
        }
        return doc;
      });
      saveSelectedDocumentsToStorage(updatedDocuments);
      return {
        ...state,
        selectedDocuments: updatedDocuments,
      };
    }
    default:
      return state;
  }
};
